'use strict';

var skeletonBorderRadiusMapper = require('../../../../../../../../_virtual/skeletonBorderRadiusMapper.cjs');

/**
 * Get the border radius based on the Skeleton type and isCircular flag
 * @param isCircular
 * @param type
 * @returns string
 */ const getBorderRadius = (isCircular, type)=>{
    switch(true){
        case isCircular:
        case type === "avatar":
            return "circular";
        case type === "typography":
            return "small";
        default:
            return "medium";
    }
};

skeletonBorderRadiusMapper.__exports.getBorderRadius = getBorderRadius;

module.exports = skeletonBorderRadiusMapper.__exports;
//# sourceMappingURL=skeletonBorderRadiusMapper.cjs.map
